export const UPDATE_LAYOUT = 'dt/layouts/UPDATE_LAYOUT';
export const COPY_LAYOUT = 'dt/layouts/COPY_LAYOUT';
export const RESET_LAYOUT = 'dt/layouts/RESET_LAYOUT';
export const SAVE_LAYOUT = 'dt/layouts/SAVE_LAYOUT';
export const LAYOUT_SAVED = 'dt/layouts/LAYOUT_SAVED';
export const NOTIFY_PAGE_CHANGES = 'dt/layouts/NOTIFY_PAGE_CHANGES ';

export const updateLayout = (siteId, layout, isImportingLayout = false) => ({
  type: UPDATE_LAYOUT,
  siteId,
  layout,
  isImportingLayout,
});

export const copyLayout = (siteId, layout) => ({ type: COPY_LAYOUT, siteId, layout });

export const resetLayout = (siteId) => ({ type: RESET_LAYOUT, siteId });

export const saveLayout = (siteId, layout) => ({ type: SAVE_LAYOUT, siteId, layout });

export const layoutSaved = (siteId, layout) => ({ type: LAYOUT_SAVED, layout, siteId });

export const notifyPageChanges = (title) => ({
  type: NOTIFY_PAGE_CHANGES,
  title,
});
